module.exports = __webpack_public_path__ + "static/media/invoices.bd2f275c.svg";